import React, { useState } from "react";
import phone from "../assets/img/social/phone-call.png";
import added from "../assets/img/social/add.png";
import telegram from "../assets/img/social/telegram.png";

function CustomChatBot() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="fixed bottom-24 right-6 z-50 flex flex-col items-end gap-4">
      <div
        className={`
            flex flex-col items-end gap-3 transition-all duration-300 ease-out
            ${
              isOpen
                ? "opacity-100 translate-y-0 scale-100 visible"
                : "opacity-0 translate-y-10 scale-90 invisible"
            }
        `}
      >
        <div className="flex items-center gap-2 mr-2">
          <span className="bg-gray-700 text-white text-sm py-1.5 px-3 rounded-md shadow-lg whitespace-nowrap">
            Call Us
          </span>
          <button
            onClick={() => (window.location.href = "tel:+85512345678")}
            className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center shadow-lg hover:bg-yellow-600 transition-colors"
          >
            <img
              src={phone}
              alt="Phone"
              className="rounded-full invert brightness-0 w-6 h-6"
            />
          </button>
        </div>
        <div className="flex items-center gap-2 mr-2">
          <span className="bg-gray-700 text-white text-sm py-1.5 px-3 rounded-md shadow-lg whitespace-nowrap">
            Telegram
          </span>
          <button
            type="button"
            onClick={() => window.open("https://t.me/manticcup", "_blank")}
            className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center shadow-lg hover:bg-yellow-600 transition-colors"
          >
            <img
              src={telegram}
              alt="telegram"
              className="rounded-full invert brightness-0 w-6 h-6"
            />
          </button>
        </div>
      </div>
      <button
        onClick={toggleMenu}
        className={`
            w-14 h-14 rounded-full shadow-xl flex items-center justify-center text-white 
            transition-all duration-300 ease-in-out z-50 overflow-hidden
            ${isOpen ? "bg-gray-600" : "bg-yellow-600 rotate-0"} 
        `}
        aria-label="Toggle Menu"
      >
        {isOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <img
            src={added}
            alt="support"
            className="object-cover invert brightness-0"
          />
        )}
      </button>
    </div>
  );
}

export default CustomChatBot;
